import Link from 'next/link';
import getConfig from 'next/config';
import { useRouter } from "next/router";
import host from "@/utils/host";
import { APIFinishRedPoint, APIGetCheckV2Permissions, APIGetUserInfo } from "@/api";
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import useDispatchAction from "@/hooks/useDisptachAction";
import { setUserInfo } from "@/redux/actions/home";
import { Avatar, Input, message, Modal, Popover, Select } from "antd";
import { getQueryString, isMobile } from "@/utils/action";
import LoginModal from "@/components/LoginModal";
import { LoadingOutlined } from "@ant-design/icons";
import NotAuthModal from "@/components/NotAuthModal/index";
import { ArrowDownIcon, ClearIcon, SearchIcon } from "@/config/config";
import SubNotAuthMobile from '@/components/SubNotAuthMobile';
import LogoutModal from "@/components/LogoutModal";
import SearchDropDown from "@/components/SearchDropDown";
import MoreMobileModal from '@/components/MoreMobileModal';
import AuthorizationModal from "@/components/AuthorizationModal";
import gaTracker from "@/ga";
import Image from "next/image";
import eventSub, { EventName } from "@/common/EventSub";
import { Icon } from "@iconify/react";
import useLanguage from "@/hooks/useLanguage";
import AppImage from "@/components/AppImage";
// import Popup from '@/components-mobile/Popup';
const { Option } = Select;
const { publicRuntimeConfig: { staticFolder } } = getConfig();
const disabledPages = ['/hot-product-mobile', '/hotsale', '/product', 'details-mobile']; // 需要禁用的页面路径

const Header = () => {
  const { t, isUS, changeLanguageWithoutReload, changeLanguage, currentLang, langList } = useLanguage();
  const router = useRouter();
  const userInfo = useSelector(state => state.home.userInfo.userInfo);

  const [mobile, setMobile] = useState();
  const [openConnectModal, setOpenConnectModal] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const [goPageModal, setGoPageModal] = useState(false);
  const [notAuth, setNotAuth] = useState(false);
  const [notAuthMobile, setNotAuthMobile] = useState(false);

  const [showNeedAuthModal, setShowNeedAuthModal] = useState(false);
  const [userPermissions, setUserPermissions] = useState(-1); // -1:等待接口返回， 1:已经授权  0:未授权

  const [showRedPoint, setShowRedPoint] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(false);
  const dispatchAction = useDispatchAction({ setUserInfo });

  // 获取 URL 参数中的 country 并切换语言
  useEffect(() => {
    const { country } = router.query;
    if (country) {
      changeLanguageWithoutReload(country);
    }
  }, []); // 只在组件挂载时执行一次

  const getUserInfo = () => {
    console.log(t('log.start_get_user_info'), Date.now());
    const token = localStorage.getItem("token");
    if (token) {
      const localUserInfo = localStorage.getItem("user");
      if (localUserInfo) {
        console.log(t('log.local_info'), JSON.parse(localUserInfo), Date.now());
        dispatchAction.setUserInfo(localUserInfo);
      }
      APIGetUserInfo().then(async resp => {
        console.log('~11111111a');
        if (resp.data.user) {
          const user = resp.data.user;
          await checkPermission();
          dispatchAction.setUserInfo(user);
          setShowRedPoint(user.needShowcaseRedPoint);
          localStorage.setItem("user", JSON.stringify(user));
        }
      });
    }
  };
  const goSearchPage = () => {
    router.push("/search-page-mobile/");
  };

  const goProfile = () => {
    setGoPageModal(false);
    router.push('/profile-mobile');
  };
  const goCollection = () => {
    let localUserInfo = localStorage.getItem("user");
    localUserInfo = JSON.parse(localUserInfo);
    setGoPageModal(false);
    router.push(`/collection-mobile?obtain=${localUserInfo?.obtain}`);
  };

  const goShowcase = (type) => {
    if (!userPermissions) {
      setNotAuthMobile(true);
      return;
    }
    setGoPageModal(false);
    if (type === 'commission') {
      APIFinishRedPoint({}).then(resp => {
        if (resp.data.result) {
          setShowRedPoint(false);
        }
      });
    }
    let localUserInfo = localStorage.getItem("user");
    localUserInfo = JSON.parse(localUserInfo);
    router.push(mobile ? `/showcase-mobile?type=${type}&obtain=${localUserInfo?.obtain}` : '/person-center?tabKey=2');
  };
  const goAnalysis = () => {
    if (!userPermissions) {
      setNotAuthMobile(true);
      return;
    }
    setGoPageModal(false);
    router.push('/analysis-mobile');
  };

  const checkPermission = async () => {
    await new Promise((resolve) => {
      APIGetCheckV2Permissions().then(resp => {
        if (resp.data) {
          setUserPermissions(resp.data?.permissions ? 1 : 0);
          resolve();
        }
      }).finally(() => {
        resolve();
      });
    });
  };

  useEffect(() => {
    // 初始化获取用户信息和权限
    const token = localStorage.getItem("token");
    if (token) {
      checkPermission().then();
    }

    // 监听页面可见性变化（标签页切换）
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const token = localStorage.getItem("token");
        if (token) {
          checkPermission(); // 页面切换回来时调用 checkPermission
        }
      }
    };

    // 绑定事件监听
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // 清理事件监听
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const gotoShowcase = (tabKey) => {
    if (userPermissions === 1) {
      router.push(`/person-center?tabKey=${tabKey}`);
    } else {
      setShowNeedAuthModal(true);
    }
  };

  const gotoNoCheckPermissions = (tabKey) => {
    router.push(`/person-center?tabKey=${tabKey}`);
  };

  const gotoCommission = (tabKey) => {
    gaTracker.trackEvent("comm_increase", true);
    if (!(userInfo?.displayName || userInfo?.avatarUrl)) {
      setOpenConnectModal(true);
      return;
    }

    if (userPermissions === 1) {
      APIFinishRedPoint({}).then(resp => {
        if (resp.data.result) {
          setShowRedPoint(false);
        }
      });
      router.push(`/person-center?tabKey=${tabKey}&subKey=2`);
    } else {
      setShowNeedAuthModal(true);
    }
  };

  const watchSearchbarVis = () => {
    setShowSearchIcon(false);
  };

  const watchSearchbarUnVis = () => {
    setShowSearchIcon(true);
  };
  const showIconH5 = useMemo(() => {
    if (!["/"].includes(router.pathname)) {
      return true;
    }
    return showSearchIcon;
  }, [showSearchIcon, router]);
  useEffect(() => {
    setMobile(isMobile());
    const tokenStr = getQueryString("token");
    const state = getQueryString("state");
    const errMsg = getQueryString("errMsg");
    const localState = localStorage.getItem("userTiktokState");
    if (tokenStr && state === localState) {
      localStorage.setItem("token", tokenStr);
      router.push("/");
    }
    if (errMsg) {
      setNotAuth(true);
    }
    eventSub.subscribe(EventName.HomeSearchShow, watchSearchbarVis);
    eventSub.subscribe(EventName.HomeSearchUnShow, watchSearchbarUnVis);
    return () => {
      eventSub.unsubscribe(EventName.HomeSearchShow, watchSearchbarVis);
      eventSub.unsubscribe(EventName.HomeSearchUnShow, watchSearchbarUnVis);
    };
  }, []);

  useEffect(() => {
    getUserInfo();
  }, []);

  const h5PageList = [
    {
      text: t('header.menu.profile'),
      icon: '/images/header/people-icon.svg'
    },
    {
      text: t('header.menu.collection'),
      icon: '/images/header/collection-icon.svg'
    },
    {
      text: t('header.menu.showcase'),
      icon: '/images/header/showcase-icon.svg'
    },
    {
      text: t('header.menu.commission_increase'),
      icon: '/images/header/Commission-icon.svg'
    },
    {
      text: t('header.menu.earnings_analysis'),
      icon: '/images/header/earn-icon.svg'
    },
    {
      text: t('header.menu.logout'),
      icon: '/images/header/logout-icon.svg'
    },
  ];
  const selectPageH5 = (data) => {
    if (data === t('header.menu.profile')) {
      goProfile();
      gaTracker.trackEvent("profile");
    } else if (data === t('header.menu.collection')) {
      goCollection();
      gaTracker.trackEvent("collection");
    } else if (data === t('header.menu.showcase')) {
      goShowcase('showcase');
      gaTracker.trackEvent("showcase");
    } else if (data === t('header.menu.commission_increase')) {
      goShowcase('commission');
      gaTracker.trackEvent("comm_increase");
    } else if (data === t('header.menu.earnings_analysis')) {
      goAnalysis();
      gaTracker.trackEvent("earnings_analysis");
    } else if (data === t('header.menu.logout')) {
      setLogoutModal(true);
    }
  };
  const content = (
    mobile ? <div className={"pop_content"}>
      {(currentLang?.code === 'fr' ? h5PageList.filter((_, index) => index < 2 || index > 4) : h5PageList).map((item, index) => (
        <>
          {item.text === 'Logout' && <div className='bg-[#EDF0FE] h-[1px] w-full mt-[10px] mb-[3px]'></div>}
          <div key={index} className={"relative text-[#454D6C] flex items-center px-[25px] py-[13px]"} onClick={() => selectPageH5(item?.text)}>
            <Image className={"block group-hover:hidden"} src={item.icon} width={21} height={21}></Image>
            <div className={"text-[14px] ml-[17px]"}>{item.text}</div>
            {
              currentLang?.code === 'en' && showRedPoint && item.text === (t('header.menu.commission_increase')) && <span className={"absolute top-[10px] right-[12px] rounded-full w-[5px] h-[5px] bg-[#f00]"}></span>
            }
          </div>
        </>
      ))}
    </div> :
      <div className={"pop_content"}>
        <Link className={"w-full"} href={"/person-center?tabKey=1"}>
          <div className={"group h-[47px] rounded-[4px] text-[#454D6C] hover:text-[#F0774A] hover:font-500 cursor-pointer px-[20px] w-full flex items-center hover:bg-[#FFF1E4] trans-all"}>
            <Image className={"block group-hover:hidden"} src={"/images/header/people-icon.svg"} width={20} height={21}></Image>
            <Image className={"hidden group-hover:block"} src={"/images/header/people-icon-active.svg"} width={20} height={21}></Image>
            <div className={"text-[14px] ml-[17px]"}>{t('person_center.my_profile')}</div>
          </div>
        </Link>
        <Link className={"w-full"} href={"/person-center?tabKey=3"}>
          <div className={"group h-[47px] rounded-[4px] text-[#454D6C] hover:text-[#F0774A] hover:font-500 cursor-pointer px-[20px] w-full flex items-center hover:bg-[#FFF1E4] trans-all"}>
            <Image className={"block group-hover:hidden"} src={"/images/header/collection-icon.svg"} width={20} height={21}></Image>
            <Image className={"hidden group-hover:block"} src={"/images/header/collection-icon-active.svg"} width={20} height={21}></Image>
            <div className={"text-[14px] ml-[17px]"}>{t("person_center.my_collection")}</div>
          </div>
        </Link>
        {
          isUS ? <>
            <div onClick={() => gotoShowcase(2)} className={"h-[47px] group rounded-[4px] text-[#454D6C] hover:text-[#F0774A] hover:font-500 cursor-pointer px-[20px] w-full flex items-center hover:bg-[#FFF1E4] trans-all"}>
              <Image className={"block group-hover:hidden"} src={"/images/header/showcase-icon.svg"} width={20} height={21}></Image>
              <Image className={"hidden group-hover:block"} src={"/images/header/showcase-icon-active.svg"} width={20} height={21}></Image>
              <div className={"text-[14px] ml-[17px]"}>My Showcase</div>
            </div>
            <div onClick={() => gotoShowcase(5)} className={"h-[47px] group rounded-[4px] text-[#454D6C] hover:text-[#F0774A] hover:font-500 cursor-pointer px-[20px] w-full flex items-center hover:bg-[#FFF1E4] trans-all"}>
              <Image className={"block group-hover:hidden"} src={"/images/header/earn-icon.svg"} width={20} height={21}></Image>
              <Image className={"hidden group-hover:block"} src={"/images/header/earch-icon-active.svg"} width={20} height={21}></Image>
              <div className={"text-[14px] ml-[17px]"}>Earnings Analysis</div>
            </div>
          </> : null
        }
        <div className={"bg-[#EDF0FE] h-[1px] w-full my-2"}></div>
        <div onClick={(e) => {
          setLogoutModal(true);
        }} className={"h-[47px] group rounded-[4px] text-[#454D6C] hover:text-[#F0774A] hover:font-500 cursor-pointer px-[20px] w-full flex items-center hover:bg-[#FFF1E4] trans-all"}>
          <Image className={"block group-hover:hidden"} src={"/images/header/logout-icon.svg"} width={20} height={21}></Image>
          <Image className={"hidden group-hover:block"} src={"/images/header/logout-icon-active.svg"} width={20} height={21}></Image>
          <div className={"text-[14px] ml-[17px]"}>{t('header.menu.logout')}</div>
        </div>
      </div>
  );

  const languageContent = (<div className={` ${mobile ? "w-[180px]" : "pop_content w-[213px]"} text-[#222222] text-[14px]`}>
    <div className={"!font-bold !text-left w-full"}>{t('header.region.select')}</div>
    <div className={"text-[12px] !text-left w-full mt-[3px] text-[#A7A7A7]"}>{t('header.region.select_desc')}</div>
    <div className={"bg-[#E3E3E399] h-[1px] w-full my-[10px]"}></div>
    <div className={"w-full flex flex-col gap-[10px]"}>
      {
        langList.map(item => {
          return <div onClick={() => changeLanguage(item?.code)} className={`${item?.code === currentLang?.code ? "bg-[#F0774A33] text-[#F76D4D]" : ""} h-[42px] w-full rounded-[8px] flex items-center px-[10px] cursor-pointer hover:bg-[#F0774A33]`}>
            <AppImage src={item?.icon} className={"!w-[30px] !h-[30px] rounded-full"}></AppImage>
            <div className={"ml-[10px]"}>{item?.name}</div>
          </div>;
        })
      }
    </div>
  </div>);


  return (
    <div id='header_bar' className='header_container'>
      <NotAuthModal show={notAuth} mobile={mobile} onCancel={() => setNotAuth(false)} />
      <AuthorizationModal show={showNeedAuthModal} onCancel={() => setShowNeedAuthModal(false)}></AuthorizationModal>
      <Link href='/'>
        <div className={"flex items-center "}>
          <div className='logo-container'>
            <img className='logo' alt='logo' src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/anystarr-next-asset/anystarr_icon.png"} />
          </div>
        </div>
      </Link>
      <LoginModal open={openConnectModal} mobile={mobile} onCancel={() => setOpenConnectModal(false)}></LoginModal>
      <LogoutModal show={logoutModal} onCancel={() => setLogoutModal(false)}></LogoutModal>


      <div className='right-container '>

        {mobile === false ? <>
          {
            router.pathname === "/" ? <Popover arrow={false} content={languageContent} placement={"bottomRight"}>
              <div className={"px-[5px] min-w-[100px] cursor-pointer mr-[15px] h-[36px] rounded-full flex items-center font-400 text-[14px] text-[#222] bg-[#F0774A1A]"}>
                <AppImage src={currentLang.icon} className={"!mr-[9px] fit-cover !rounded-full !border-[#E3E3E3] !border-[1px] !w-[30px] !h-[30px]"}></AppImage>
                {currentLang.name}
              </div>
            </Popover> : <div className={"cursor-not-allowed px-[5px] opacity-50 min-w-[100px] cursor-pointer mr-[15px] h-[36px] rounded-full flex items-center font-400 text-[14px] text-[#222] bg-[#F0774A1A]"}>
              <AppImage src={currentLang.icon} className={"!mr-[9px] fit-cover !rounded-full !border-[#E3E3E3] !border-[1px] !w-[30px] !h-[30px]"}></AppImage>
              {currentLang.name}
            </div>
          }
        </> : null
        }

        {mobile === false && <SearchInput />}

        <div id={"header_anystarr_wrap"} className={"relative flex items-center "}>
          {mobile === false && <>
            <Link href={"/helpCenter?key=0"} target={"_blank"}>
              {/* <div className={"w-6 h-6 trans-all cursor-pointer hover:opacity-70 rounded-full flex items-center text-sm font-bold mr-3 justify-center text-color4 border-[2px] border-color4"}>*/}
              {/*  <Image src={"/images/question-icon.svg"} className={"w-[7px]"} alt={""} width={7} height={14}></Image>*/}
              {/* </div>*/}
              <Icon icon={"mynaui:question-circle"} className={"w-6 h-6 trans-all cursor-pointer hover:opacity-70 mr-3"}></Icon>

            </Link>
            {
              isUS ? <div onClick={() => gotoCommission(2)} className={"relative cursor-pointer mr-[20px]"}>
                <div className={"text-color2 text-sm hover:text-primary"}>{t('header.commission')}</div>
                {
                  showRedPoint && <div className={"absolute top-[-2px] bg-[#f00] left-[-3px] w-1.5 rounded-full h-1.5"}></div>
                }
                {
                  <Image className={"absolute top-[-14px] right-[-10px] w-6 h-4"} src={"/images/up_top_commission.gif"} alt={""} width={10} height={10}></Image>
                }
              </div> : null
            }
          </>}

          {/* {mobile === true && <img className={"w-[40px] h-[40px] mr-[4px]"} src={SearchIcon} onClick={goSearchPage} />}/images/search.png */}
          {mobile === true && showIconH5 && <img className={"w-[24px] h-[24px] mr-[12px]"} src={"/images/search.png"} onClick={goSearchPage} />
            //  <Image width={16} height={16} alt={""} className={"w-[26px] h-[26px] mr-[12px] bg=[#F0774A]"} src={"/images/search.png"} onClick={goSearchPage} />
          }
          {mobile === true && !disabledPages.some(page => router.pathname.includes(page)) && <Popover arrow={false} content={languageContent} placement={"bottomRight"}>
            <div className={" p-[1px] rounded-full !border-[#7D8FAD] !border-[1px] flex items-center justify-center !mr-[9px]"}>
              <AppImage src={currentLang.icon} className={" fit-cover !rounded-full !w-[22px] !h-[22px]"}></AppImage>
            </div>

          </Popover>}
          {mobile === true && disabledPages.some(page => router.pathname.includes(page)) && <AppImage src={currentLang.icon} className={"!mr-[9px] fit-cover !rounded-full !border-[#E3E3E3] !border-[1px] !w-[22px] !h-[22px] opacity-50"}></AppImage>}
          {mobile && <Link href={"/helpCenter?key=0"} target={"_blank"}>
            <img alt={""} className={'w-[30px] h-[30px] mr-[12px]'} src={'/images/famicons_help-circle.png'} />
          </Link>}
          {
            userInfo?.displayName || userInfo?.avatarUrl ?
              mobile ?
                <div className={"flex items-center cursor-pointer pr-[16px] "} onClick={() => setGoPageModal(!goPageModal)}>
                  <Avatar id='step3' className={'avatar'} size={32} src={userInfo?.avatarUrl}> </Avatar>
                  {
                    currentLang?.code === 'en' && showRedPoint && <div className={"absolute top-[7px] right-[16px] rounded-full w-[5px] h-[5px] bg-[#f00]"}></div>
                  }
                </div>
                : <Popover
                  arrow={false}
                  trigger={"hover"}
                  placement={'bottomRight'}
                  content={content}
                  overlayInnerStyle={{
                    borderRadius: 20,
                    border: "1px solid #F4F6FE"
                  }}
                >
                  <div onClick={() => gotoNoCheckPermissions(1)} className={"flex items-center cursor-pointer"}>
                    <Avatar size={35} src={userInfo?.avatarUrl}></Avatar>
                    <span className={"user_name_wrap text-sm text-color2 font-400"} style={{ marginLeft: "10px" }}>{userInfo?.displayName}</span>
                    <img className={"w-4 h-4 ml-2"} src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/down_black.png"}></img>
                  </div>
                </Popover>
              : <>
                <div onClick={() => setOpenConnectModal(true)} className={`link_wallet ${mobile ? 'loginHeadH5' : 'w-[100px]'}`}>
                  {t('login.title')}
                </div>
              </>
          }
        </div>
      </div>

      <SubNotAuthMobile
        isVisible={notAuthMobile}
        confirmText={'Authorize Now'}
        closePopup={() => setNotAuthMobile(false)} />
      <MoreMobileModal isVisible={goPageModal} content={content} closePopup={() => setGoPageModal(false)}></MoreMobileModal>
    </div >);
};

const SearchInput = () => {
  const [open, setOpen] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [currenSearchType, setCurrentSearchType] = useState(2); // 1 pid 2 name 3 佣金率
  const currenSearchTypeRef = useRef(2); // 1 pid 2 name 3 佣金率
  const [openHistory, setOpenHistory] = useState(false);
  const handleChange = (value) => {
    currenSearchTypeRef.current = value;
    setCurrentSearchType(value);
  };
  const router = useRouter();
  const [showSearchIcon, setShowSearchIcon] = useState(false);

  const onSearch = () => {
    router.push(`/?s=${searchName}&t=${currenSearchType}&state=${Math.floor(Math.random() * 10)}`);
    setSearchName("");
    setOpen(false);
    gaTracker.trackEvent("search", true);
  };

  const onHisSearch = (name, type) => {
    router.push(`/?s=${name}&t=${type}&state=${Math.floor(Math.random() * 10)}`);
    setSearchName("");
    setOpen(false);
  };

  useEffect(() => {
    setMobile(isMobile());
    setCurrentSearchType(2);
  }, [open]);

  useEffect(() => {
    setOpenHistory(false);
  }, [open]);

  const showIcon = useMemo(() => {
    if (!["/"].includes(router.pathname)) {
      return true;
    }
    return showSearchIcon;
  }, [showSearchIcon, router]);

  const watchSearchbarVis = () => {
    setShowSearchIcon(false);
  };

  const watchSearchbarUnVis = () => {
    setShowSearchIcon(true);
  };

  useEffect(() => {
    eventSub.subscribe(EventName.HomeSearchShow, watchSearchbarVis);
    eventSub.subscribe(EventName.HomeSearchUnShow, watchSearchbarUnVis);
    return () => {
      eventSub.unsubscribe(EventName.HomeSearchShow, watchSearchbarVis);
      eventSub.unsubscribe(EventName.HomeSearchUnShow, watchSearchbarUnVis);
    };
  }, []);

  return <div>
    {
      showIcon &&
      <div className={"bg-[#FDEFE9] rounded-full p-1 cursor-pointer hover:opacity-70 mr-[19px] trans-all fade_in"}>
        <Icon onClick={() => {
          gaTracker.trackEvent("search", true);
          setOpen(!open);
        }} icon={"mynaui:search"} className={"text-[#F0774A] text-[22px] "}></Icon>
      </div>
      // <Image onClick={() => {
      //   gaTracker.trackEvent("search", true);
      //   setOpen(!open);
      // }} alt={""} width={26} height={26} className={"search_icon fade_in !w-[26px] !h-[26px] object-cover mr-[19px]"} src={"/images/search-icon.png"} />
    }
    <Modal destroyOnClose={true} rootClassName={"global_search"} width={mobile ? null : 720} centered={!mobile} footer={null} title={null} closable={false} open={open} onCancel={() => setOpen(false)}>

      <div style={{
        display: "flex",
        justifyContent: "center"
      }}>
        <Popover
          overlayInnerStyle={{
            padding: "0",
            background: "#00000000",
            zIndex: 9999,
            boxShadow: "none",
            width: "720px"
          }} zIndex={9999} arrow={false} open={openHistory} onOpenChange={(v) => {
            setOpenHistory(v);
          }}

          getTooltipContainer={() => document.getElementById("searchBar-modal")} getPopupContainer={() => document.getElementById("searchBar-modal")}
          placement={"bottom"} trigger={"click"} content={
            <SearchDropDown onBlur={() => { }} hover={() => { }} show={() => { }} noHover={() => { }} onSearch={(e, item) => {
              setSearchName(item.name);
              setCurrentSearchType(Number(item.type));
              onHisSearch(item.name, Number(item.type));
              setOpenHistory(false);
            }} />}
        >
          <div id={"searchBar-modal"} className={"w-[720px]"}>
            <Searchbar
              handleChange={handleChange}
              closeHistory={() => setOpenHistory(false)}
              currenSearchType={currenSearchType}
              searchName={searchName}
              setSearchName={setSearchName}
              onSearch={onSearch}
            ></Searchbar>
          </div>
        </Popover>
      </div>
    </Modal>
  </div>;
};

export const Searchbar = ({ style = {}, leftStyle = {}, mobile = false, handleChange, currenSearchType, searchName, setSearchName, onSearch, loading = false, closeHistory }) => {
  const { t } = useLanguage();
  return <div className={"m_wrap"}>
    <div style={style} className={`search_warp ${searchName ? "border_search" : ""}`}>
      <div onClick={(e) => {
        e.stopPropagation();
        closeHistory?.();
      }} style={leftStyle} className={"left_wrap !font-bold !text-[#4E4E4E]"}>
        <Select onFocus={() => {
          closeHistory?.();
        }} suffixIcon={<img src={ArrowDownIcon} className={"w-[8.5px] h-[4.5px] pointer-events-none"} />} popupMatchSelectWidth={false} onClick={(e) => {
          e.stopPropagation();
        }} rootClassName={"left_wrap !font-bold search_wrap_bar_down"} onChange={handleChange} labelRender={(v) => {
          return currenSearchType === 1 ? <span className={"text-[#4E4E4E]"}>{t('search.type.product_link')}</span> : <span className={"text-[#4E4E4E]"}>{t('search.type.product_name')}</span>;
        }} defaultValue={currenSearchType} value={currenSearchType}>
          <Option key={2} value={2} className={"!text-[4e4e4e]"}>{mobile ? "Name" : t('search.type.product_name')}</Option>
          <Option key={1} value={1} className={"!text-[4e4e4e]"}>{mobile ? "Link" : t('search.type.product_link')}</Option>
        </Select>
      </div>
      <Input style={{
        height: 44
      }} onClear={() => {
        closeHistory();
        onSearch("", currenSearchType);
      }} allowClear={
        {
          clearIcon: <img className={"w-[16px] h-[16px]"} src={ClearIcon} />
        }
      } value={searchName} onChange={(e) => setSearchName(e.target.value)}
        onPressEnter={() => {
          closeHistory();
          onSearch(searchName, currenSearchType);
        }}
        placeholder={currenSearchType === 1 ? t('header.search.placeholder_link') : t('header.search.placeholder_name')}
        className={"input"}></Input>
      <div onClick={() => {
        closeHistory();
        onSearch(searchName, currenSearchType);
      }} className={"right_wrap bg-linear h-full w-[65px]"}>
        {loading && <div className={"w-[48px] h-[48px] flex items-center justify-center text-white"}><LoadingOutlined></LoadingOutlined></div>}
        {!loading && <Image width={22} height={22} alt={""} className={"w-[22px] h-[22px]"} src={"/images/input-search-icon.png"} />}
      </div>
    </div>
  </div>;
};


export default Header;
